<template>
  <v-card color="transparent" flat light>
    <v-card-text>
      <v-container py-0>
        <v-layout row wrap>
          <v-flex md6 xs12 px-2>
            <entity-field
              v-model="localTeam.entityId"
              v-validate="'required'"
              :readonly="!canEditEntity"
              :clearable="canEditEntity"
              :label="
                $t('action.actions.select', { field: $tc('models.entity') }) +
                ' (*)'
              "
              :data-vv-name="$tc('models.entity')"
              :error-messages="errors.collect($tc('models.entity'))"
            />
          </v-flex>

          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="localTeam.name"
              v-validate="'required'"
              :readonly="!edit"
              :disabled="!localTeam.entityId"
              :label="$t('fields.global.name') + ' (*)'"
              :data-vv-name="$t('fields.global.name')"
              :error-messages="errors.collect($t('fields.global.name'))"
            >
              <template #append>
                <div class="d-flex align-center" style="pointer-events: auto">
                  <v-tooltip
                    v-model="tooltipOpen"
                    open-on-hover="false"
                    bottom
                    transition="scale-transition"
                  >
                    <template #activator="{ attrs }">
                      <v-icon
                        v-bind="attrs"
                        dense
                        color="primary"
                        class="ml-2"
                        @mouseenter="tooltipOpen = true"
                        @mouseleave="tooltipOpen = false"
                      >
                        info
                      </v-icon>
                    </template>

                    <div
                      @mouseenter="tooltipOpen = true"
                      @mouseleave="tooltipOpen = false"
                      v-html="$t('fields.teams.nameTooltip')"
                    />
                  </v-tooltip>
                </div>
              </template>
            </v-text-field>
          </v-flex>
          <!-- <v-flex xs12 pa-2>
            <button-upload
              :label="$t('fields.global.logo')"
              :image.sync="imageLogo"
              :title.sync="titleFileLogo"
              @file="file => $emit('update:fileLogo',file)"
            />
          </v-flex>-->
          <!-- Home Img -->
          <v-flex md6 xs12>
            <button-upload
              :label="$t('fields.global.homeImg')"
              :image.sync="imageHomeImg"
              :title.sync="titleFileHomeImg"
              @file="(file) => $emit('update:fileImgHome', file)"
            />
          </v-flex>
          <v-flex md5 pr-2>
            <category-menu
              v-model="localTeam.categoryId"
              clearable
              :label="
                $t('action.actions.select', {
                  field: $tc('models.category'),
                })
              "
              :data-vv-name="$tc('models.category')"
              :error-messages="errors.collect($tc('models.category'))"
            />
          </v-flex>
          <v-flex md1>
            <v-text-field
              v-model="localTeam.letter"
              v-validate="'required'"
              :readonly="!edit"
              :disabled="!localTeam.entityId"
              :label="$t('titles.global.word') + ' (*)'"
              :data-vv-name="$t('titles.global.word')"
              :error-messages="errors.collect($t('titles.global.word'))"
            />
          </v-flex>
          <v-flex v-if="localTeam._id" md6 xs12 px-2>
            <v-switch
              v-model="localTeam.lineUpCompleted"
              :label="$t('fields.teams.lineUpCompleted')"
              color="primary"
              :readonly="!edit"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-switch
              v-model="localTeam.active"
              :label="$t('fields.global.active')"
              color="primary"
              :readonly="!edit"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import CategoryMenu from '@/components/management/categories/CategoryMenu'
import EntityField from '@/components/widgets/Input/EntityField'
import ButtonUpload from '@/components/widgets/button/ButtonUpload'

export default {
  name: 'TabInformation',
  components: {
    ButtonUpload,
    EntityField,
    CategoryMenu,
  },
  props: {
    team: {
      type: Object,
      required: true,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: true,
      required: false,
    },
    entityId: {
      type: String,
      default: '',
      required: false,
    },
    fileImgHome: { type: [File, String], default: '', required: false },
    fileLogo: { type: [File, String], default: '', required: false },
  },
  data() {
    return {
      imageLogo: '',
      titleFileLogo: '',
      imageHomeImg: '',
      titleFileHomeImg: '',
      tooltipOpen: false,
    }
  },
  watch: {
    'team.logo': {
      handler: function (val) {
        if (val) {
          if (val.includes('http')) this.imageLogo = val
          else this.imageLogo = this.defaultValues.imageUrl + val
        } else {
          this.imageLogo = ''
        }
        this.titleFileHomeImg = val
        this.$emit('update:fileLogo', '')
      },
      immediate: true,
      deep: true,
    },
    'team.homeImg': {
      handler: function (val) {
        if (val) {
          if (val.includes('http')) this.imageHomeImg = val
          else this.imageHomeImg = this.defaultValues.imageUrl + val
        } else {
          this.imageHomeImg = ''
        }

        this.titleFileHomeImg = val
        this.$emit('update:fileImgHome', '')
      },
      immediate: true,
      deep: true,
    },
    'team.entityId': {
      handler: function (val, oldVal) {
        if (oldVal) {
          this.team.trainers = []
          this.team.players = []
        }
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.teams.loading,
    }),
    localTeam: {
      get() {
        return this.team
      },
      set(value) {
        this.$emit('update:team', value)
      },
    },
    canEditEntity() {
      return (
        this.isAdmin || (!this.localTeam._id && !this.entityId && this.edit)
      )
    },
  },
  methods: {
    clear() {
      this.$validator.reset()
    },
    fetchName(item) {
      this.localTeam.name = item[0].abbreviation
        ? item[0].abbreviation
        : item[0].text
    },
  },
}
</script>
